module.exports = __webpack_public_path__ + "img/mining-bg.b9e1cfa0.png";